export function cleanPoemText(text) {
  return (text || '').replace(/[，。！？、；：""''\s\n\r]/g, '');
}

function lcsLength(a, b) {
  const m = a.length;
  const n = b.length;
  const dp = Array.from({ length: m + 1 }, () => Array(n + 1).fill(0));

  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      if (a[i - 1] === b[j - 1]) {
        dp[i][j] = dp[i - 1][j - 1] + 1;
      } else {
        dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1]);
      }
    }
  }

  return dp[m][n];
}

function levenshteinDistance(a, b) {
  const m = a.length;
  const n = b.length;
  if (m === 0) return n;
  if (n === 0) return m;

  const dp = Array.from({ length: m + 1 }, () => Array(n + 1).fill(0));
  for (let i = 0; i <= m; i++) dp[i][0] = i;
  for (let j = 0; j <= n; j++) dp[0][j] = j;

  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      if (a[i - 1] === b[j - 1]) {
        dp[i][j] = dp[i - 1][j - 1];
      } else {
        dp[i][j] = 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
      }
    }
  }

  return dp[m][n];
}

export function computePoemMatchScore(recognizedText, standardText) {
  const recognized = cleanPoemText(recognizedText);
  const standard = cleanPoemText(standardText);

  if (!standard) {
    return {
      score: 0,
      matched: recognized,
      total: '',
      accuracy: '0/0',
      matchedChars: 0,
      totalChars: 0
    };
  }

  if (!recognized) {
    return {
      score: 0,
      matched: '',
      total: standard,
      accuracy: `0/${standard.length}`,
      matchedChars: 0,
      totalChars: standard.length
    };
  }

  const matchedChars = lcsLength(recognized, standard);
  const lcsScore = matchedChars / standard.length;
  const maxLen = Math.max(recognized.length, standard.length);
  const editDist = levenshteinDistance(recognized, standard);
  const editScore = 1 - editDist / maxLen;
  const combined = lcsScore * 0.6 + editScore * 0.4;
  const score = Math.round(Math.max(0, Math.min(100, combined * 100)));

  return {
    score,
    matched: recognized,
    total: standard,
    accuracy: `${matchedChars}/${standard.length}`,
    matchedChars,
    totalChars: standard.length
  };
}

export function getReadEncouragement(score) {
  if (score >= 95) return '完美！发音标准，朗读声情并茂！🎉';
  if (score >= 90) return '太棒了！你的发音非常标准！🎉';
  if (score >= 80) return '很好！朗读流畅，个别字词可以再打磨！👍';
  if (score >= 70) return '不错！继续练习，发音会更标准！💪';
  if (score >= 50) return '还可以！建议对照原文多读几遍！📖';
  if (score >= 30) return '别灰心！跟着示范音频再练一次吧！💪';
  if (score > 0) return '朗读内容与原文差距较大，请对照原文重试！🔍';
  return '未能识别到有效内容，请重新录音试试！🎤';
}

export function getReciteEncouragement(score) {
  if (score >= 95) return '完美！一字不漏，背诵非常标准！🎉';
  if (score >= 90) return '太棒了！你的背诵非常流畅！🎉';
  if (score >= 80) return '很好！只有少量字词需要改进！👍';
  if (score >= 70) return '不错！再对照原文练习几次会更完美！💪';
  if (score >= 60) return '基本记住了！注意漏背或错背的部分！📖';
  if (score >= 40) return '还需努力！建议先看着提示多读几遍！📚';
  if (score >= 20) return '离完整背诵还有距离，别灰心，继续加油！💪';
  if (score > 0) return '背诵内容与原文差距较大，请先熟悉古诗再试！🔍';
  return '未能识别到有效内容，请重新录音试试！🎤';
}
